import Service 			from "./../../Libs/Service";

let Banner = new Service({

	Name: "Banner",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Получение креативов текущего издателя
		'BannerScriptChanged': function(bannerTemplateCodename) {

			if (Creative.SelectedCreative?.templateProps?.codename === bannerTemplateCodename) {

				Broadcast.call("Selected Banner Script Changed");

			}

		}

	},

	init() {

	}

});

window.Banner = Banner;

export { Banner }

